module.exports = __webpack_public_path__ + "img/logoIcon.0727a76c.png";